// @flow
import { useState, useCallback, useEffect } from 'react';

import { api } from 'app/api';

import {
  GET_PAYMENT_ORDERS,
  type PaymentOrdersResult,
  type PaymentOrder,
} from 'app/common/api/requests/cafeteria/customer/payment_orders';


export type { PaymentOrder, PaymentOrdersResult };

export default function usePaymentOrders(customerId: number, schoolId?: number) {
  const [state, setState] = useState<PaymentOrdersResult>({});
  const [loading, setLoading] = useState<boolean>(true);

  const handleRequest = useCallback(async () => {
    setLoading(true);
    const res = await api.request(GET_PAYMENT_ORDERS, {
      error: 'Не удалось получить данные по квитанциям',
      params: {
        customer_id: customerId,
        school_id: schoolId,
        for_camp: !!schoolId,
      },
    });
    setLoading(false);

    if (res) {
      setState(res);
    }
  }, [customerId, schoolId]);

  useEffect(() => {
    handleRequest();
  }, [handleRequest]);


  return [{
    state,
    loading,
  }, {
    request: handleRequest,
  }];
}
